import { render, staticRenderFns } from "./study-sharing.vue?vue&type=template&id=6525c99d&scoped=true&"
import script from "./study-sharing.vue?vue&type=script&lang=ts&"
export * from "./study-sharing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525c99d",
  null
  
)

export default component.exports